import styled from "styled-components";

export const FilterStateContainer = styled.div``;

export const TableContainer = styled.div`
  height: 530px;
  overflow-y: auto;
`;
